class StreamBlockModal extends HTMLElement {
  constructor() {
    super();
    this.modal = null;
    this.modalContent = null;
    this.controller = new AbortController();
  }

  connectedCallback() {
    this.modal = this.querySelector('[data-modal]');
    this.modalContent = this.querySelector('[data-modal-content]');

    if (!this.modal || !this.modalContent) return;

    this.querySelectorAll('[data-modal-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', this.openModal, {
        signal: this.controller.signal,
      });
    });

    this.querySelectorAll('[data-modal-close]').forEach((closer) => {
      closer.addEventListener('click', this.closeModal, {
        signal: this.controller.signal,
      });
    });

    this.querySelector('[data-modal-content]')?.addEventListener(
      'click',
      (e) => {
        e.stopPropagation();
      },
      { signal: this.controller.signal }
    );

    document.addEventListener(
      'keydown',
      (e) => {
        if (e.key === 'Escape' && !this.modal.classList.contains('hidden'))
          this.closeModal();
      },
      { signal: this.controller.signal }
    );
  }

  disconnectedCallback() {
    this.closeModal();
    this.controller.abort();
  }

  openModal = () => {
    const videoType = this.dataset.videoType;
    const videoUrl = this.dataset.videoUrl;
    const youtubeId = this.dataset.youtubeId;

    this.modal.classList.remove('hidden');
    document.body.style.overflow = 'hidden';

    if (videoType === 'youtube' && youtubeId) {
      const iframe = document.createElement('iframe');
      iframe.className = 'w-full h-full';
      iframe.src = `https://www.youtube.com/embed/${encodeURIComponent(youtubeId)}?autoplay=1&rel=0`;
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
      );
      iframe.setAttribute('allowfullscreen', '');
      this.modalContent.appendChild(iframe);
    } else if (videoType === 'vimeo' && videoUrl) {
      const video = document.createElement('video');
      video.className = 'w-full h-full object-contain';
      video.controls = true;
      video.autoplay = true;
      const source = document.createElement('source');
      source.src = videoUrl;
      source.type = 'video/mp4';
      video.appendChild(source);
      this.modalContent.appendChild(video);
    }
  };

  closeModal = () => {
    const video = this.modalContent.querySelector('video');
    if (video) {
      video.pause();
      video.removeAttribute('src');
      video.load();
    }
    this.modal.classList.add('hidden');
    document.body.style.overflow = '';
    this.modalContent.innerHTML = '';
  };
}

if (!customElements.get('stream-block-modal')) {
  customElements.define('stream-block-modal', StreamBlockModal);
}
